module.exports = __webpack_public_path__ + "static/media/slider1.2edeb7c5.png";